export default __webpack_public_path__ + "static/media/github.adb057e9.svg";